import React, { Component } from 'react';
import firebase from 'firebase';
import { Tabs, Tab, ButtonToolbar, Button, Grid, Row, Col, ListGroup, ListGroupItem, Badge } from 'react-bootstrap';
import { LANG } from '../../config';
import { notify } from 'react-notify-toast';
import WordModal from './WordModal';
import ModalImport from './ModalImport';
import Loading from '../../components/Loading';

type IProps = {
  room: string,
}

type IState = {
  path: string,
  lessons: Object,
  lessonIndex: number,
  items: Object,
  modal: Object,
  import: boolean,
  loading: boolean,
}

class Words extends Component {

  constructor(props) {
    super(props);

    this.state = {
      lessons: {},
      lessonIndex: 0,
      items: {},
      modal: null,
      import: false,
      loading: true,
    };
  }

  state: IState;

  componentDidMount() {
    const { room } = this.props;

    firebase.database()
    .ref(`room/${room}/lessons`)
    .on('value', (snapshot) => {
      this.setState(
        {
          lessons: snapshot.val() || {},
        },
        this.reload,
      );
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.lessonIndex !== this.state.lessonIndex || prevState.lessons !== this.state.lessons) {
      this.reload();
    }
  }

  reload() {
    this.setState(
      {
        loading: true,
      },
      () => {
        const { room } = this.props;
        const { lessons, lessonIndex } = this.state;
        const lessonKey = Object.keys(lessons)[lessonIndex];
        if (!lessonKey) return;

        firebase.database()
        .ref(`room/${room}/words`)
        .orderByChild('lesson')
        .equalTo(lessonKey)
        .on('value', (snapshota) => {
          this.setState({
            loading: false,
            items: snapshota.val() || {},
          });
        });
      },
    );
  }

  handleChangeTab(lessonIndex: number) {
    this.setState({
      lessonIndex,
    });
  }

  handleSave(item: Object) {
    const { room } = this.props;
    const { lessons, lessonIndex } = this.state;
    const lessonKey = Object.keys(lessons)[lessonIndex];

    const key = item.key || firebase.database().ref().child(`room/${room}/words`).push().key;

    const updates = {
      [`room/${room}/words/${key}`]: {
        original: item.original,
        lesson: lessonKey,
        [LANG.OTHER]: item.other,
      }
    };

    firebase.database().ref().update(updates);

    this.setState({
      modal: null,
    });

    notify.show(`Words were updated!`, 'success', 3000);
  }

  handleRemove() {
    const { room } = this.props;
    const { modal } = this.state;

    if (modal.key) {
      firebase.database()
      .ref(`room/${room}/words/${modal.key}`)
      .remove();
    }

    this.setState({
      modal: null,
    });

    notify.show(`Word was removed!`, 'success', 3000);
  }

  handleSelect(key: string) {
    const { items } = this.state;
    this.setState({
      modal: { key, ...items[key] },
    });
  }

  props: IProps;

  render() {
    const { lessons, loading } = this.state;
    if (Object.keys(lessons).length === 0 && loading) return <Loading />;

    const { lessonIndex, items, modal } = this.state;

    return (
      <Grid>
        <Tabs defaultActiveKey={lessonIndex} onSelect={this.handleChangeTab.bind(this)} animation={false} style={{ marginTop: '30px', marginBottom: '30px' }}>
          <Tab title="Lesson" disabled />
          {
            Object.keys(lessons).map((key, index) => (
              <Tab 
                key={key}
                eventKey={index}
                title={lessons[key].name} />
            ))
          }
        </Tabs>
        <Row style={{ marginBottom: '30px' }}>
          <Col xs={12}>
            <div style={{ float: 'right' }}>
              <Badge bsStyle="default">{Object.keys(items).length} words</Badge>
            </div>
            <ButtonToolbar>
              <Button bsStyle="success" onClick={() => this.setState({ modal: {} })}>Add Word</Button>
              <Button bsStyle="info" onClick={() => this.setState({ import: true })}>Import words</Button>
            </ButtonToolbar>
          </Col>
        </Row>
        {
          loading 
            ? <Loading />
            : (
              <div>
                <ListGroup>
                {
                  Object.keys(items).map((key) => (
                    <ListGroupItem key={key} header={items[key].original} onClick={(e) => this.handleSelect(key)}>
                    {
                      items[key][LANG.OTHER].map(item => <div>{item}</div>)
                    }
                    </ListGroupItem>
                  ))
                }
                </ListGroup>
                {
                  Object.keys(items).length === 0 && <p>No words in this lesson.</p>
                }
              </div>
            )
        }
        
        {
          this.state.import && <ModalImport onImport={this.handleSave.bind(this)} onClose={() => this.setState({ import: false })} />
        }

        <WordModal
          item={modal}
          onClose={() => this.setState({ modal: null })} 
          onSave={this.handleSave.bind(this)}
          onRemove={this.handleRemove.bind(this)}
        />
      </Grid>
    );
  }
}

export default Words;



// WEBPACK FOOTER //
// ./src/pages/Words/index.js